import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { NavMarker } from 'react-rhumb';
import { CollectionSection } from '../components/CollectionSection';
import { Hero } from '../components/Hero';
import { SuggestionSection } from '../components/SuggestionSection';
import { HeaderView } from '../components/headers/HeaderView';
import { useGetSuggestionSections } from '../hooks/useGetSuggestionSections';
import { useSplitSuggestionSections } from '../hooks/useSplitSuggestionSections';
import { createMockCollection, createMockListing } from '../queries/mockHomepageData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ProductPage({
  productType
}) {
  const {
    loading,
    error,
    data: suggestionSections
  } = useGetSuggestionSections();
  const {
    sections,
    remainingSections
  } = useSplitSuggestionSections({
    suggestionSections,
    start: 0,
    end: 1
  });
  const collection = createMockCollection();
  const listings = Array.from({
    length: 6
  }, createMockListing);
  if (loading) {
    return /*#__PURE__*/_jsx("div", {
      children: "Loading..."
    });
  }
  if (error) {
    return /*#__PURE__*/_jsxs("div", {
      children: ["Error: ", error.message]
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: `${productType}S_LOAD`,
    children: /*#__PURE__*/_jsxs(DashboardPage, {
      headerComponent: /*#__PURE__*/_jsx(HeaderView, {}),
      children: [/*#__PURE__*/_jsx(Hero, {
        text: `${productType} Hero`
      }), sections === null || sections === void 0 ? void 0 : sections.map((section, index) => /*#__PURE__*/_jsx(SuggestionSection, Object.assign({}, section), index)), /*#__PURE__*/_jsx(CollectionSection, {
        title: collection.name,
        description: collection.description,
        imageUrl: collection.imageSrc,
        collectionSlug: collection.name,
        cards: listings
      }), remainingSections === null || remainingSections === void 0 ? void 0 : remainingSections.map((section, index) => /*#__PURE__*/_jsx(SuggestionSection, {
        sectionType: section.sectionType,
        cards: section.cards
      }, index))]
    })
  });
}